import { Route, Routes } from "react-router-dom";

import ForceSignOut from "../pages/Auth/ForceSignOut";
import SignOutOidc from "../pages/Auth/SignOutOidc";
import AppInsightsTest from "../pages/AppInsightsTest";

function UnauthenticatedRoutes() {
  return (
    <Routes>
      <Route path="/signout-callback" element={<SignOutOidc />} />
      <Route path="/logout" element={<ForceSignOut />} />
      <Route path="/appinsight" element={<AppInsightsTest />} />
      <Route path="/*" element={<div>Redirecting to login...</div>} />
    </Routes>
  );
}

export default UnauthenticatedRoutes;
